import { useTranslation } from 'react-i18next'

import Icon from '../../../components/ui/Icon'
import { HeroStat } from '../../../components/guest/home/stat/HeroStat'
import { StaticHomeHeroCourt } from './StaticHomeHeroCourt'

const BOOKING_PHONE = '0774 158 714'
const BOOKING_PHONE_HREF = 'tel:0774158714'

export const StaticHome = () => {
  const { t } = useTranslation('home')

  const stats = [
    {
      key: 'open',
      value: '2',
      label: t('static.stats.open'),
    },
    {
      key: 'building',
      value: '+1',
      label: t('static.stats.building'),
    },
    {
      key: 'app',
      value: t('static.stats.app.value'),
      label: t('static.stats.app.label'),
    },
  ] as const

  return (
    <div className="container-fluid g-0 hero p-xl-5">
      <div className="row hero-row flex-xl-row g-4 g-xl-0 gx-xl-5">
        <div className="col-12 col-xl-6 hero-content text-xl-start align-items-xl-start">
          <div className="eyebrow mb-16">{t('static.eyebrow')}</div>

          <h1 className="hero-h">
            {t('static.title.before')}
            <br />
            <span className="hero-title-highlight">
              {t('static.title.highlight')}
            </span>
            <br />
            {t('static.title.middle')}
            <br />
            <span className="hero-title-highlight">
              {t('static.title.location')}
            </span>
          </h1>

          <p className="hero-description mx-xl-0">{t('static.description')}</p>

          <div className="hero-actions">
            <a
              href={BOOKING_PHONE_HREF}
              className="btn rounded-2 btn-primary btn-lg btn-block w-100 w-xl-auto"
            >
              <Icon name="phone" size={16} />
              {t('static.cta', { phone: BOOKING_PHONE })}
            </a>
          </div>

          <div className="hero-stat-list">
            {stats.map(stat => (
              <HeroStat key={stat.key} value={stat.value} label={stat.label} />
            ))}
          </div>
        </div>

        <div className="col-12 col-xl-6 hero-court-col align-self-xl-stretch">
          <StaticHomeHeroCourt
            eyebrow={t('static.court')}
            callLabel={t('static.call', { phone: BOOKING_PHONE })}
            callHref={BOOKING_PHONE_HREF}
          />
        </div>
      </div>
    </div>
  )
}
